import { Analytics } from './analytics';
import { ItemAction } from '../../../item/actions/item_action';

export class ItemImageDetailClickAnalytics extends Analytics {
    constructor() {
        super();

        ItemAction.ANALYTICS_ITEM_DISPLAY_CLICK_EVENT.on((analyticsItemDisplayClick) => {
            this.run(() => {
                const data = analyticsItemDisplayClick.analyticsData;
                const item = data.item;
                const productName = item.getProductName();
                const medicalMaterialType = item.getMedicalMaterialType();
                const displayItemImage = `${productName}_${data.index}/${data.length}`;
                const prop65 = `${item._catalogItemCode}_${data.index}/${data.length}`;
                const linkAnalyticsData = {
                    server: 'club/pc',
                    fName: '商品詳細画像_クリック',
                    events: ['event156'],
                    items: [this.items(
                        productName,
                        medicalMaterialType,
                        item._events)],
                    sku: productName,
                    displayItemImage: displayItemImage,
                    club: {
                        server: 'club/pc',
                        prop5: '商品詳細画像_クリック',
                        events: ['event156'],
                        products: [this.products(
                            item._catalogItemCode,
                            medicalMaterialType,
                            item._events)],
                        prop25: item._catalogItemCode,
                        prop65: prop65,
                    }
                };
                window.sc_trackLinkAll(linkAnalyticsData, analyticsItemDisplayClick.target, 'o', 'ClkChangeProdImage');
            });
        });
    }

    private items(productName: string, evars: string, events: Array<string>) {
        return {
          category: '',
          productName: productName,
          quantity: '',
          price: '',
          events: events,
          evars: this.medicalMaterialType(evars)
        };
    }

    private products(productName: string, evars: string, events: string[]) {
        return {
            category: '',
            productName: productName,
            quantity: '',
            price: '',
            events: events,
            evars: this.eVar79(evars)
        };
    }

    private medicalMaterialType(evars: string) {
        return { medicalMaterialType: evars };
    }

    private eVar79(evars: string) {
        return { eVar79: evars };
    }
}
